import TypographyInput from "./TypographyInput";

export default TypographyInput;
